import {
  RAIL_STATE_IDS,
  VIDEO_LAYOUT_IDS,
  normalizeRailStateId,
  normalizeVideoLayoutId,
} from './layoutIds'

function getStorage(storage) {
  if (storage) {
    return storage
  }

  if (typeof window === 'undefined') {
    return null
  }

  return window.localStorage
}

export function readStoredVideoLayout(
  storageKey,
  fallbackValue = VIDEO_LAYOUT_IDS.stageOverlay,
  storage,
) {
  const resolvedStorage = getStorage(storage)
  if (!resolvedStorage || !storageKey) {
    return fallbackValue
  }

  return normalizeVideoLayoutId(resolvedStorage.getItem(storageKey), fallbackValue)
}

export function writeStoredVideoLayout(storageKey, layoutId, storage) {
  const resolvedStorage = getStorage(storage)
  if (!resolvedStorage || !storageKey) {
    return
  }

  resolvedStorage.setItem(storageKey, normalizeVideoLayoutId(layoutId))
}

export function readStoredRailState(
  storageKey,
  fallbackValue = RAIL_STATE_IDS.stacked,
  storage,
) {
  const resolvedStorage = getStorage(storage)
  if (!resolvedStorage || !storageKey) {
    return fallbackValue
  }

  return normalizeRailStateId(resolvedStorage.getItem(storageKey), fallbackValue)
}

export function writeStoredRailState(storageKey, railStateId, storage) {
  const resolvedStorage = getStorage(storage)
  if (!resolvedStorage || !storageKey) {
    return
  }

  resolvedStorage.setItem(storageKey, normalizeRailStateId(railStateId))
}
